/**
 * generate-cid — thin domain wrapper for the cid generator.
 *
 * The actual UUID-derived generator lives in `src/lib/tag-codec.ts`
 * (alongside the encode/decode pair, since the cid is part of the
 * tag schema). Re-exporting through the domain layer lets usecases
 * stay oblivious to the codec internals.
 */
import { generateCid } from '@/lib/tag-codec'

/** Generate a new citation id. Format: `c-` prefix + 10 alphabet
 *  chars. Stable identity for the chip across reverify cycles. */
export function generateChipCid(): string {
  return generateCid()
}
